import { createContext } from 'react';

export const inputRefContext = createContext<React.RefObject<HTMLInputElement>>({
  current: null,
});
